<template>
  <a-modal
    title="审稿意见"
    :visible="visible"
    width="700px"
    :dialog-style="{ top: '30px' }"
    @cancel="() => (this.visible = false)"
    :destroyOnClose="true"
    :footer="null"
    :maskClosable="false"
  >
    <div class="viewOpinion">
      <div id="note">{{ finalOpinion }}</div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "ViewOpinion",
  props: {
    infoData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      code: "",
      finalOpinion: "",
    };
  },
  mounted() {},
  methods: {
    show() {
      this.$nextTick(() => {
        this.visible = true;
        this.code = this.infoData.code;
        this.listData();
      });
    },
    listData() {
      let _this = this;
      _this.axios
        .get("/manuscripts/queryAuthorManuscriptHistory", {
          params: {
            code: _this.code,
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            let finalOpinion = res.data.data.finalOpinion;
            if (finalOpinion != undefined) {
              _this.finalOpinion = finalOpinion;
            }
          } else {
            _this.utils.messageInfo(
              _this,
              "error",
              "查询作者稿件历史记录失败！"
            );
          }
        });
    },
  },
};
</script>

<style scoped>
.btn {
  color: #1890ff;
  border-color: #1890ff;
  margin: 0 10px;
}
</style>
